import React from 'react';
import { AutocompleteRenderGroupParams } from '@material-ui/lab/Autocomplete/Autocomplete';
import ListSubheader from '@material-ui/core/ListSubheader';
import { Components } from '../../types';

export const Group: NonNullable<Components['Group']> = (params: AutocompleteRenderGroupParams) => [
  !!params.group ? (
    <ListSubheader key={params.key} component="div">
      {params.group}
    </ListSubheader>
  ) : null,
  params.children
];
